import React, { useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

//styles
import { ImgSt } from "./StButton.elements";

//images
import st from "../../img/numeric/st/st.png";

const StButton = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <Link to="/settings/stleads">
      {!state.ecg ? (
        <ImgSt src={st} style={{ opacity: "0" }} />
      ) : (
        <ImgSt src={st} />
      )}
    </Link>
  );
};

export default StButton;
